/* eslint-disable no-console */
const Location = require('utils/Location');
const store = require('store/Store');
const watch = require('redux-watch');
const { getConstructorRecommendations, transformConstructorResponseForCarousel } = require('utils/ConstructorRecs');
const { CONSTRUCTOR_PODS } = require('constants/constructorConstants');
const { updateConstructorRecommendations } = require('actions/ConstructorRecsActions');

function fetchConstructorRecommendations(params) {
    const podId = Location.isHomepage() ? CONSTRUCTOR_PODS.RFY : CONSTRUCTOR_PODS.YMAL;
    getConstructorRecommendations(podId, params).then(res => {
        const { pod, results } = res.response;
        const items = transformConstructorResponseForCarousel(results);
        store.dispatch(updateConstructorRecommendations({ podId, constructorTitle: pod.display_name, constructorRecommendations: items }));
    });
}

function initialize() {
    const currentProductWatcher = watch(store.getState, 'constructorRecommendations.constructorRequestParams');
    store.subscribe(
        currentProductWatcher(params => {
            if (window.ConstructorioClient && Location.isConstructorRecommendationsEnabledPage()) {
                if (!global.constructorio) {
                    const { queryParams } = window.ConstructorioTracker.options;
                    const setRecommendationsClientOptions = {
                        apiKey: queryParams.autocomplete_key,
                        sessionId: queryParams.s,
                        userId: queryParams.ui,
                        serviceUrl: `https://${Sephora.configurationSettings?.constructorServiceUrl}`
                    };
                    global.constructorio = new window.ConstructorioClient(setRecommendationsClientOptions);
                }

                fetchConstructorRecommendations(params);
            }
        }),
        { ignoreAutoUnsubscribe: true }
    );
}

module.exports = { initialize };
